
import React from "react";
import { Helmet } from "react-helmet-async";
import AdminLayout from "@/components/admin/AdminLayout";
import { useAdminProtectedRoute } from "@/contexts/admin-context";
import ValidationLogsViewer from "@/components/admin/ValidationLogsViewer";

const AdminFileValidation: React.FC = () => {
  // Protect the route for admin access only
  const { loading } = useAdminProtectedRoute();

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin h-8 w-8 border-4 border-primary border-t-transparent rounded-full"></div>
      </div>
    );
  }

  return (
    <>
      <Helmet>
        <title>File Validation Logs - Admin Dashboard</title>
      </Helmet>
      <AdminLayout>
        <div className="p-6">
          <h1 className="text-3xl font-bold mb-6">File Security Validation</h1>
          <ValidationLogsViewer />
        </div>
      </AdminLayout>
    </>
  );
};

export default AdminFileValidation;
